import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SimulationDsService } from '@app/core/data-services';
import { notificationTopic } from '@app/shared/utils';
import { LoadingNotificationService } from 'chronos-shared';
import { finalize } from 'rxjs/operators';
import moment from 'moment';

@Component({
  selector: 'app-clock-in-modal',
  templateUrl: './clock-in-modal.component.html',
  styleUrls: ['./clock-in-modal.component.scss']
})
export class ClockInModalComponent implements OnInit {
  public selectedStartTime: Date;
  public maxSelectableDate: Date;
  public isDateValid = false;
  public setInAllWorkCenters = false;
  public checkBoxLabel = 'MODAL_FOOTER.CLOCKIN_WARNING';

  public readonly INPUT_STYLE = { width: '270px' };
  public readonly LOADING_TOPIC = notificationTopic.modalProductionPeriods;

  constructor(private ref: DynamicDialogRef, private simulationDsService: SimulationDsService) {}

  public ngOnInit(): void {
    this.maxSelectableDate = moment().utc().toDate();
  }

  public startOrder(): void {
    LoadingNotificationService.publish(this.LOADING_TOPIC, true);
    this.simulationDsService
      .clockInFilterDate(this.selectedStartTime, this.setInAllWorkCenters)
      .pipe(
        finalize(() => {
          LoadingNotificationService.publish(this.LOADING_TOPIC, false);
        })
      )
      .subscribe(() => {
        this.ref.close();
      });
  }

  public closeModal(): void {
    this.ref.close();
  }

  public checkValidity(): void {
    this.isDateValid = this.selectedStartTime <= this.maxSelectableDate;
  }
}
